import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, Clock, XCircle, ArrowRight } from "@phosphor-icons/react";
import api from "../../lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }

    let cancelled = false;

    const poll = async () => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        attempts.current += 1;
        if (attempts.current >= 8) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch (_e) {
        attempts.current += 1;
        if (attempts.current >= 8) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      }
    };

    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  const IconForStatus = () => {
    if (status === "paid") return <CheckCircle size={64} weight="duotone" className="text-emerald-400" />;
    if (status === "checking") return <Clock size={64} weight="duotone" className="text-brand animate-pulse" />;
    return <XCircle size={64} weight="duotone" className="text-[#FF6B61]" />;
  };

  const messages = {
    checking: { title: "Processing payment…", body: "Please hold on while we confirm with Stripe." },
    paid: { title: "Payment received.", body: "Your payment has been marked as made. Receipt sent to your email." },
    expired: { title: "Session expired", body: "Looks like the checkout session expired. Try again from your payments page." },
    timeout: { title: "Still processing", body: "We haven't confirmed yet — refresh in a minute or check your payments page." },
    error: { title: "No session", body: "Missing session ID." },
  };
  const m = messages[status];

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white p-6" data-testid="payment-success-page">
      <div className="card-flat max-w-md w-full p-10 text-center">
        <div className="mb-6 flex justify-center"><IconForStatus /></div>
        <div className="tracker text-brand mb-3">[ Payment ]</div>
        <h1 className="font-display text-4xl mb-3">{m.title}</h1>
        <p className="text-zinc-400 mb-8">{m.body}</p>
        {info && info.amount_total > 0 && (
          <div className="card-flat p-4 mb-6">
            <div className="tracker mb-2">Amount</div>
            <div className="font-display text-3xl money">{info.currency?.toUpperCase()} {(info.amount_total / 100).toFixed(2)}</div>
          </div>
        )}
        <Link to="/client" className="btn-primary justify-center w-full" data-testid="back-to-portal">
          Back to portal <ArrowRight size={16} weight="bold" />
        </Link>
      </div>
    </div>
  );
}
